var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssisted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6,
    fill: "#EFF1FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 4H10V5.5H8C6.61929 5.5 5.5 6.61929 5.5 8V10H4V8C4 5.79086 5.79086 4 8 4ZM4 16V14H5.5V16C5.5 17.3807 6.61929 18.5 8 18.5H10V20H8C5.79086 20 4 18.2091 4 16ZM14 5.5V4H16C18.2091 4 20 5.79086 20 8V10H18.5V8C18.5 6.61929 17.3807 5.5 16 5.5H14ZM18.5 14H20V16C20 18.2091 18.2091 20 16 20H14V18.5H16C17.3807 18.5 18.5 17.3807 18.5 16V14ZM8.5 15.5H10.3184L10.7788 14.0303H13.1963L13.6577 15.5H15.4761L13.1143 8.5H10.8618L8.5 15.5ZM12.7928 12.7451L12.0137 10.2637H11.959L11.1815 12.7451H12.7928Z",
    fill: "#3E4AE7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssisted);
export default __webpack_public_path__ + "static/media/assisted.6feef7ff9aee96a4e7975eeae78fa664.svg";
export { ForwardRef as ReactComponent };